import React from "react";
import Title from "../home/Title";
import AboutMe from "./AboutMe";
import MyServices from "./MyServices";
import { isItalianDevice } from "../../utils/utils";

const About = () => {
  return (
    <section id="about" className="w-full">
      <Title title="About" subTitle="Me" />
      <AboutMe />
      <Title
        title={isItalianDevice() ? "I miei" : "My"}
        subTitle={isItalianDevice() ? "Interessi" : "Interests"}
      />
      <MyServices />
    </section>
  );
};

export default About;
